import { apiClient } from './apiClient';
import { ChatRequest, ChatResponse } from '../types/chat.types';

/**
 * Envía un mensaje al agente FCT y retorna la respuesta.
 * El timeout del chat es mayor que el default porque el agente puede tardar.
 */
export const sendChatMessage = async (request: ChatRequest): Promise<ChatResponse> => {
  const response = await apiClient.post<ChatResponse>('/v1/chat', request, {
    timeout: 60000, // 60 segundos para el chat
  });
  return response.data;
};
